var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "d7ae58adf0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.488281 151.464844 L 318.238281 151.464844 L 318.238281 223.464844 L 56.488281 223.464844 Z M 56.488281 151.464844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1e47d62265"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63.558594 158.238281 L 187.332031 158.238281 L 187.332031 216.761719 L 63.558594 216.761719 Z M 63.558594 158.238281 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d7ae58adf0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.750202, 0, 0, 0.749268, 56.489269, 151.465449)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M -0.00131637 -0.000808127 L 348.904932 -0.000808127 L 348.904932 96.092952 L -0.00131637 96.092952 L -0.00131637 -0.000808127 ",
    stroke: "#64ffda",
    strokeWidth: 6,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1e47d62265)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#64ffda",
    d: "M 63.558594 158.238281 L 188.035156 158.238281 L 188.035156 217.363281 L 63.558594 217.363281 Z M 63.558594 158.238281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#64ffda",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(193.793972, 197.420553)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.300781 0 L 8.519531 0 L 8.519531 -11.035156 L 12.714844 -5.160156 L 16.789062 -5.160156 L 20.953125 -11.003906 L 20.953125 0 L 27.171875 0 L 27.171875 -21.761719 L 22.070312 -21.761719 L 14.734375 -11.410156 L 7.429688 -21.761719 L 2.300781 -21.761719 Z M 2.300781 0 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#64ffda",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(223.255949, 197.420553)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.300781 0 L 17.5625 0 L 17.5625 -5.128906 L 8.519531 -5.128906 L 8.519531 -8.488281 L 16.382812 -8.488281 L 16.382812 -13.523438 L 8.519531 -13.523438 L 8.519531 -16.695312 L 17.222656 -16.695312 L 17.222656 -21.761719 L 2.300781 -21.761719 Z M 2.300781 0 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#64ffda",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.213555, 197.420553)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.300781 0 L 11.535156 0 C 18.558594 0 23.222656 -4.320312 23.222656 -10.878906 C 23.222656 -17.410156 18.558594 -21.761719 11.535156 -21.761719 L 2.300781 -21.761719 Z M 8.582031 -5.625 L 8.582031 -16.132812 L 11.347656 -16.132812 C 14.671875 -16.132812 16.816406 -14.082031 16.816406 -10.878906 C 16.816406 -7.679688 14.671875 -5.625 11.347656 -5.625 Z M 8.582031 -5.625 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#64ffda",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(266.4855, 197.420553)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.300781 0 L 8.582031 0 L 8.582031 -21.761719 L 2.300781 -21.761719 Z M 2.300781 0 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#64ffda",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(277.362811, 197.420553)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.15625 0 L 6.808594 0 L 7.988281 -3.078125 L 15.417969 -3.078125 L 16.601562 0 L 23.285156 0 L 14.828125 -21.761719 L 8.609375 -21.761719 Z M 9.296875 -7.679688 L 11.71875 -14.425781 L 14.144531 -7.679688 Z M 9.296875 -7.679688 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.770888, 196.670553)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.515625 0 L 3.359375 0 L 5.292969 -4.808594 L 15.609375 -4.808594 L 17.605469 0 L 20.417969 0 L 11.707031 -21.171875 L 9.226562 -21.171875 Z M 6.320312 -7.289062 L 10.464844 -17.453125 L 14.609375 -7.289062 Z M 6.320312 -7.289062 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(120.000127, 196.670553)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.085938 0 L 5.714844 0 L 5.714844 -16.574219 L 17.421875 0 L 19.902344 0 L 19.902344 -21.171875 L 17.300781 -21.171875 L 17.300781 -4.597656 L 5.597656 -21.171875 L 3.085938 -21.171875 Z M 3.085938 0 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(145.286098, 196.670553)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.085938 0 L 5.746094 0 L 5.746094 -21.171875 L 3.085938 -21.171875 Z M 3.085938 0 "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAm);
export default __webpack_public_path__ + "static/media/AM.871a02ab62688748e9d9c23d3b02e0eb.svg";
export { ForwardRef as ReactComponent };